module.exports = __webpack_public_path__ + "img/SAGold.png";